import { ZoraType } from './zora';

/** Liquidity Score price impact thresholds per token type */
export const LS_THRESHOLDS: Record<string, number> = {
  DEFAULT: 2.5,
  ZORA_CREATOR: 3.5,
  ZORA_POST: 3.5,
};

/** Determines the price impact threshold to use in calculating the liquidity score based on the type of token passed in */
export const getPriceImpactThreshold = (zoraType: ZoraType): number => {
  if (zoraType === 'creator') {
    return LS_THRESHOLDS.ZORA_CREATOR;
  } else if (zoraType === 'post') {
    return LS_THRESHOLDS.ZORA_POST;
  }

  return LS_THRESHOLDS.DEFAULT;
};
